export interface BaseModalInterface {
  title: string;
}
